module.exports = __webpack_public_path__ + "img/NG.fd19d3e9.jpg";